import { Tooltip } from '@mui/material'
import { useEffect, useState } from 'react'

const TogglePlayerButton = ({setActive, clearActiveState, setAnimation, animationCollection, data, setData, iconname, setIconClicked, hideAnnotations, iconSelect}) => {
    const [title, setTitle] = useState('')
    const [icon, setIcon] = useState('')
    const handleToggle = (event, type) => {
        hideAnnotations()
        switch(type) {
            case 'cutView':
                setAnimation((animationCollection[type]));
                setData('idle')
                setActive(event, "control-active");
                break

            case 'idle' :
                setAnimation((animationCollection[type]));
                setData('cutView')
                clearActiveState()
                break
            
            case 'exploded' :
                setAnimation((animationCollection[type]));
                setData('combine')
                setActive(event, "control-active");
                break

            case 'combine':
                setAnimation((animationCollection[type]));
                setData('exploded')
                clearActiveState()
                break
                
            default:
                break

        }        
    }

    useEffect(() => {
        setIcon(`assets\\white-icon`+'\\'+iconname)
    },[iconname])

    useEffect(() => {
        if(data){
            switch(data){
                case 'cutView':
                    setTitle("Cutout View")
                    break

                case 'idle':
                    setTitle('Idle View')
                    break

                case 'exploded':
                    setTitle("Exploded View")
                    break

                case 'combine':
                    setTitle('Combined View')
                    break

                default:
                    break
            }
        }
    },[data])


    return (
        <>
            <Tooltip className="my-tooltip" title={title} arrow>
                <div onClick={(e) => handleToggle(e, data, setIconClicked(iconSelect))} className="on-cursor mx-1"  data-name="controls" >
                    <img className="overlay-cutaway img-icon"  id="previous"  src={icon}  alt="img" ></img>
                </div>
            </Tooltip>
        </>
    )
}

export default TogglePlayerButton